import { useEffect,useState } from "react"
import { getDocumentos } from "../../../../services/descargaDocumentos"
import { getInfoTextService } from "../../../../services/infoTextService"
//import { datosConfig } from "../../../helpers/data"
import Coberturas from "../components/Coberturas"
import Contacto from "../components/Contacto"
import FormatosGuias from "../components/FormatosGuias"
import HeadHomeOut from "../components/HeadHomeOut"
import PreguntasFrecuentes from "../components/PreguntasFrecuentes"
//import Seguro from "../components/Seguro"
import Siniestro from "../components/Siniestro"
import Glosario from "../components/Glosario"

const HomeOutScreen = () => {

    const [coberturas, setCoberturas] = useState();
    const [coberturasDesc, setCoberturasDesc] = useState();
    const [siniestros, setSiniestros] = useState();
    const [pasosSiniestros, setPasosSiniestros] = useState();
    const [preguntas, setPreguntas] = useState();

    const [condicionesGenerales, setCondicionesGenerales] = useState();
    const [derechosAsegurado, setDerechosAsegurado] = useState();
    const [formatoReclamacion, setFormatoReclamacion] = useState();
    const [guiaRapida, setGuiaRapida] = useState();
    
    useEffect(() => {
        try {
            getInfoTextService().then((resp) => {
                setCoberturas(resp.CoberturaCards);
                setCoberturasDesc(resp.CoberturaDesc);
                setSiniestros(resp.TabsSiniestro);
                setPasosSiniestros(resp.PasosSiniestro);
                setPreguntas(resp.PreguntasFrecuentes);
            })

            getDocumentos().then((resp) => {
                var docCondiciones = resp.DocumentosSponsor[0].baseDocumento
                var docDerechos = resp.DocumentosSponsor[1].baseDocumento
                var docReclamacion = resp.DocumentosSponsor[2].baseDocumento
                var docGuiaRapida = resp.DocumentosSponsor[3].baseDocumento

                setCondicionesGenerales(docGuiaRapida)
                setDerechosAsegurado(docDerechos)
                setFormatoReclamacion(docReclamacion)
                setGuiaRapida(docCondiciones)
            })
        } catch(error) {
            console.log(error)
        }

        //setCoberturas(datosConfig.CoberturaCards);
        //setSiniestros(datosConfig.TabsSiniestro);
        //setPasosSiniestros(datosConfig.PasosSiniestro);
        //setPreguntas(datosConfig.PreguntasFrecuentes);
        
    },[]);
    return (
        <>
            {/* <div>
                <main> */}
                    <HeadHomeOut pdfCondiciones={condicionesGenerales} />
                    <Coberturas coberturas={coberturas} coberturasDesc={coberturasDesc} />
                    {/*<Seguro />*/}
                    <Siniestro siniestros={siniestros} pasosSiniestros={pasosSiniestros} />
                    <FormatosGuias pdfReclamacion={formatoReclamacion} pdfDerechos={derechosAsegurado} pdfGuiaRapida={guiaRapida} />
                    <PreguntasFrecuentes preguntas={preguntas} />
                    <Glosario />
                    <Contacto />
                {/* </main>
            </div> */}
        </>
    )
}

export default HomeOutScreen